import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { usePatientsNewUserFilters, useUpdatePatientsNewUserFilter } from '../../../../../../../features/patients';
import { Button } from '../../../../../../common';

export const NewUserFilter = () => {
  const { t } = useTranslation();
  const showNewPatients = usePatientsNewUserFilters();
  const updatePatientsNewUserFilter = useUpdatePatientsNewUserFilter();

  const handleClick = useCallback(() => {
    updatePatientsNewUserFilter(!showNewPatients);
  }, [showNewPatients, updatePatientsNewUserFilter]);

  return (
    <Button
      text={t('patients.button.showNewPatients')}
      type="tertiary"
      size="sm"
      selected={showNewPatients}
      onClick={handleClick}
    />
  );
};
